import { render, staticRenderFns } from "./quick-card-footer.vue?vue&type=template&id=ba18cb98&"
import script from "./quick-card-footer.vue?vue&type=script&lang=js&"
export * from "./quick-card-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports